import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  contentContainerGrid: {
    width: "auto",
    margin: "auto",
    marginTop: -6,
    [theme.breakpoints.up("sm")]: {
      maxWidth: "53.75rem",
    },
  },

  card: {
    width: "100%",
    position: "relative",
    padding: 24,
    borderRadius: 16,
    border: "1px solid rgba(166, 181, 217, 0.18)",
    background:
      "linear-gradient(180deg, rgba(41, 42, 53, 0.65) 0%, rgba(41, 42, 53, 0.35) 100%)",
    boxShadow: "0 14px 40px rgba(0, 0, 0, 0.25)",
    overflow: "hidden",

    "&:before": {
      content: '""',
      position: "absolute",
      left: 0,
      top: 0,
      bottom: 0,
      width: 5,
      background:
        "linear-gradient(180deg, #f9d569 0%, rgba(249, 213, 105, 0.2) 100%)",
    },

    "&:after": {
      content: '""',
      position: "absolute",
      right: -120,
      top: -120,
      width: 260,
      height: 260,
      borderRadius: "50%",
      background:
        "radial-gradient(circle, rgba(249, 213, 105, 0.18) 0%, rgba(249, 213, 105, 0) 60%)",
      pointerEvents: "none",
    },

    [theme.breakpoints.down("xs")]: {
      padding: 18,
      borderRadius: 14,
    },
  },

  title: {
    fontFamily: "var(--font-family-1)",
    fontWeight: 600,
    fontSize: 20,
    lineHeight: "30px",
    textAlign: "left",
    color: "#d7def2",
    marginBottom: 14,

    [theme.breakpoints.down("xs")]: {
      fontSize: 18,
      lineHeight: "28px",
    },
  },

  paragraph: {
    fontFamily: "var(--font-family-3)",
    fontWeight: "normal",
    fontSize: 16,
    lineHeight: "24px",
    textAlign: "left",
    color: "#a6b5d9",
    marginBottom: 14,

    [theme.breakpoints.down("xs")]: {
      fontSize: 15,
      lineHeight: "22px",
    },
  },

  inlineLinkBtn: {
    appearance: "none",
    border: "none",
    background: "transparent",
    padding: 0,
    margin: 0,
    fontFamily: "var(--font-family-3)",
    color: "#f9d569",
    fontSize: "inherit",
    fontWeight: 700,
    cursor: "pointer",
    textDecoration: "underline",
    textUnderlineOffset: 4,
    transition: "color 160ms ease",

    "&:hover": {
      color: "#f9e3a3",
    },
  },

  actions: {
    marginTop: 18,
    display: "flex",
    gap: 12,
    flexWrap: "wrap",
  },

  primaryBtn: {
    fontFamily: "var(--font-family-3)",
    fontWeight: 700,
    fontSize: 14,
    lineHeight: "18px",
    borderRadius: 12,
    padding: "10px 14px",
    cursor: "pointer",
    border: "1px solid rgba(249, 213, 105, 0.55)",
    background: "rgba(249, 213, 105, 0.12)",
    color: "#f9d569",
    transition:
      "transform 160ms ease, background 160ms ease, border-color 160ms ease",

    "&:hover": {
      background: "rgba(249, 213, 105, 0.18)",
      borderColor: "rgba(249, 213, 105, 0.85)",
      transform: "translateY(-1px)",
    },

    "&:active": {
      transform: "translateY(0px)",
    },
  },

  secondaryBtn: {
    fontFamily: "var(--font-family-3)",
    fontWeight: 700,
    fontSize: 14,
    lineHeight: "18px",
    borderRadius: 12,
    padding: "10px 14px",
    cursor: "pointer",
    border: "1px solid rgba(166, 181, 217, 0.25)",
    background: "rgba(166, 181, 217, 0.06)",
    color: "#d7def2",
    transition:
      "transform 160ms ease, background 160ms ease, border-color 160ms ease",

    "&:hover": {
      background: "rgba(166, 181, 217, 0.10)",
      borderColor: "rgba(166, 181, 217, 0.40)",
      transform: "translateY(-1px)",
    },

    "&:active": {
      transform: "translateY(0px)",
    },
  },
}));

export default useStyles;
